import React, { useEffect, useRef, useState } from "react";

import VerticalLogo from "../../assets/Images/VerticalDarkLogo1.svg";
import { BiCheck, BiGridAlt, BiLock, BiLogOut, BiNotepad, BiPieChartAlt2, BiUserCircle } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineLibraryAdd, MdOutlineSettings } from "react-icons/md";
import { useLazyLogoutUserQuery } from "../../redux/API/Login/loginApi";
import { getItem, setItem } from "../../utils/token";
import { useDispatch, useSelector } from "react-redux";
import {
  changeCurrentModuleName,
  setCount,
  setCurrentTime,
  setExtendedBreaks,
  setExtraBreaks,
  setHasHighlightPopupBeenShown,
  setHighlightedContent,
  setIsModuleCompleted,
  setIsResumeTest,
  setIsTestInstructionsOpen,
  setIsTestStarted,
  setMathModuleOneQuestions,
  setParentStudentId,
  setQid,
  setReadingModuleOneQuestions,
  setResetFilters,
  setReviewPageClicked,
  setSelectTestType,
  setStrikedOptionsData,
  setTestDifficulty,
  setTestId,
  setTestName,
  setUserTestId,
} from "../../redux/Slices/startFullTestSlice";
import { openDialog, setIsTestCompletedDialogClosed } from "../../redux/Slices/dialogSlice";
import { useAssociatedetailsQuery } from "../../redux/API/ProfileSetup/profileSetupApi";
import { resetUserDataForm } from "../../redux/Slices/profileSetupSlice";
import { FaRegEdit } from "react-icons/fa";
import { clearAnswers, setCurrentQuestion, setCurrentQuestionIndex } from "../../redux/Slices/resultSlice";
import { addQuestionId, getFullName } from "../../utils";
import { useGetEnabledTestTypesQuery, useGetParentStudentInfoQuery, useLazyGetStartTestDataV1Query } from "../../redux/API/StartTest/startTestApi";
import { PiEyeBold } from "react-icons/pi";
import { RootState } from "../../redux/Store/store";
import { StudentDetail } from "../NewResults/ResultsPage";
import { createPortal } from "react-dom";

type SideBarProps = {
  handleStartTest?: (value: boolean) => void;
  route?: string;
  isFirstTest?: boolean;
};

const SideBarV1 = ({ route,isFirstTest }: SideBarProps) => {

  const [startDisable,setStartDisable] = useState(false);
  const { startedTestId } = useSelector((state: RootState) => state.root.startFullTest);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [getStartTestDataV1] = useLazyGetStartTestDataV1Query();
  const {data: enabledTestData, isSuccess:enabledTestDataSuccess} = useGetEnabledTestTypesQuery({},{skip: getItem("userRole") === "PARENT" && getItem("isCustomSAT") !== "",refetchOnMountOrArgChange:true});

  const isParent = getItem("userRole") === "PARENT";

  const sideBarOptions = [
    {
      name: "Dashboard",
      icon: <BiGridAlt size={24} />,
      href: "/dashboard",
      current: isParent ? location.pathname === "/parentdashboard"  : location.pathname === "/dashboard",
      onClick: () => navigate( isParent ? "/parentdashboard"  : "/dashboard"),
      isVisible: true,
    },
    {
      name: "Results",
      icon: <BiPieChartAlt2 size={24} />,
      href: "/practices/results",
      current: location.pathname.includes("/parentdashboard/results")  || location.pathname.includes("/practices/results"),
      onClick: () => navigate(isParent ? "/parentdashboard/results" : "/practices/results"),
      isVisible: true,
    },
    {
      name: "Preview Test",
      icon: <PiEyeBold  size={24} />,
      href: "/dashboard",
      current: location.pathname === "/previewtest",
      onClick: () => handleStartTest(true),
      isVisible: isParent ? false : true,
    },
    {
      name: "Plans  ",
      icon: <BiNotepad size={24} />,
      href: "/dashboard",
      current: location.pathname.includes("/plans") || location.pathname === "/checkout" ,
      onClick: () => navigate('/plans'),
      isVisible: true,
    },
  ];

  const startTest = async (isPreview: boolean) => {
    try {
      let body = {
        isPreviewTest: isPreview,
        isCustomTest: false,
        isFreeTest: isPreview ? false : startedTestId.isFirstTest,
        payload:{}
      }
      let response = await getStartTestDataV1(body);
      if (response.isSuccess) {
        dispatch(setIsTestInstructionsOpen(true));
        if (response.data.data) {
          localStorage.setItem(
            "currentTestName",
            response.data.data.testData.name
          );
          dispatch(setTestId(response.data.data.testData.testId));
          dispatch(setTestName(response.data.data.testData.name));

          let questions = response.data.data.testData.questions;
          let readingQuestions = questions[`ReadingAndWriting`];
          let mathsQuestions = questions[`Mathematics`];
          let readingModuleOneQuestions = [];
          let mathsModuleOneQuestions = [];

          if (response.data.data.testData.testType === "PREVIEW") {
            setItem("testType", "PREVIEW");
            readingModuleOneQuestions = addQuestionId(
              readingQuestions[`Module1`]
            );
            mathsModuleOneQuestions = addQuestionId(mathsQuestions[`Module1`]);
            dispatch(setReadingModuleOneQuestions(readingModuleOneQuestions));
            dispatch(setMathModuleOneQuestions(mathsModuleOneQuestions));
            dispatch(setUserTestId(response.data.data.testData.userTestId));
          }
        }

        dispatch(changeCurrentModuleName("writingModule1"));
        setStartDisable(false);
        if(location.pathname.includes("/practices/results") ){
          navigate("/practices/results");
        }
        if(location.pathname.includes("/purchasehistory") || location.pathname.includes("/transactionsummary") || location.pathname.includes("/plans")){
          navigate("/dashboard");
        }
      } else {
        setStartDisable(false);
        console.error("Error:", response.error);
      }
    } catch (e) {
      setStartDisable(false);
      console.error("Error:", e);
    }
  };

  const handleStartTest = (isPreview:boolean) => {
    dispatch(setCount(""));
    setStartDisable(true);
    dispatch(setHasHighlightPopupBeenShown(false));
    if (isPreview){
      setItem("testType", "PREVIEW");
      dispatch(setCurrentTime(0));
      startTest(true);
    }
    dispatch(setSelectTestType(""));
    dispatch(setExtraBreaks(false));
    dispatch(setExtendedBreaks(false));
    dispatch(setStrikedOptionsData([]));
    dispatch(setHighlightedContent([]));
    dispatch(clearAnswers());
    dispatch(setReviewPageClicked(false));
    dispatch(setIsModuleCompleted(false));
    dispatch(setResetFilters());
    dispatch(setQid(""));
    dispatch(setCurrentQuestion(""));
    dispatch(setCurrentQuestionIndex(""));
    dispatch(setIsResumeTest(false));
    setStartDisable(false);
    dispatch(setTestDifficulty({ key: "Reading", value: 'MEDIUM' }));
    dispatch(setTestDifficulty({ key: "Math", value: 'MEDIUM' }));
  };
  
  useEffect(() => {
    if(enabledTestDataSuccess && enabledTestData){
      let isCustomSAT = enabledTestData?.data?.find((item: string) => item.trim().toLowerCase().startsWith('custom'));
      if(isCustomSAT){
        setItem("isCustomSAT", "true");
      }else{
        setItem("isCustomSAT", "false");
      }
    }
  },[enabledTestData, enabledTestDataSuccess]);

  return (<>
  {isFirstTest ? (
        <section className="flex px-5 py-[10px] w-full h-[9vh] items-center justify-between rounded-[28px] border-[0.5px] border-satPrepGrey bg-satPrepTransWhite shadow-widget-card backdrop-blur-sevenFive">
          <img src={VerticalLogo} alt="logo" className="h-[8vh]" />
          <div>
            <SideBarButtons isFirstTest={true}/> 
          </div>
        </section>
      ) : (
        <section className="z-10 min-w-[150px] w-[13%] max-w-[180px] py-[10px] px-5 flex flex-col justify-between items-start self-stretch rounded-[28px] border-[0.5px] border-satPrepGrey bg-satPrepTransWhite shadow-widget-card backdrop-blur-sevenFive">
          <div className="flex flex-col items-center gap-9">
            <img src={VerticalLogo} alt="logo" className="w-4/5" />
            <div className="flex flex-col items-center gap-2 w-11/12">
              {sideBarOptions.map(
                (option) =>
                  option.isVisible && (
                    <button
                      className={`flex w-full flex-col justify-center items-center gap-[6px] py-3 px-[18px] ${
                        option.current
                          ? "text-satPrepDarkAccent rounded-md bg-satPrepLightAccent shadow-widget-card backdrop-blur-sevenFive"
                          : "text-satPrepBlack"
                      }`}
                      onClick={option.onClick}
                      disabled={option.name === "Preview Test" && startDisable}
                    >
                      {option.icon}
                      <p className="font-gully text-sm font-bold">
                        {option.name}
                      </p>
                    </button>
                  )
              )}
            </div>
          </div>

          <SideBarButtons/> 
        </section>
      )}
  </>);
};

export default SideBarV1;

const SideBarButtons = ({isFirstTest,route} : SideBarProps) => {

  const [dropdown, setDropdown] = useState(false);

  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [logoutUser] = useLazyLogoutUserQuery();
  const { data } = useAssociatedetailsQuery({});

  const isStudent = getItem("userRole") === "STUDENT";
  const isParent = getItem("userRole") === "PARENT";

  const handleClickAddParentOrStudentDetails = () => {
    if (isStudent) {
      dispatch(resetUserDataForm());
      handleOpenDialog("addParentDetails");
    } else {
      handleOpenDialog("addStudentDetails");
    }
  };

  const keyToKeep = "route";

  const handlelogOut = async () => {
    await logoutUser({});
    navigate("/login");
    dispatch(setIsTestStarted(false));
    dispatch(setIsTestInstructionsOpen(false));
    let route = getItem("route");
    if (route) {
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key !== keyToKeep) {
          localStorage.removeItem(key);
        }
      }
    } else {
      localStorage.clear();
    }
  };

  const handleOpenDialog = (dialog: string) => {
    dispatch(openDialog(dialog));
    setDropdown(false);
  };

  const isDashboard = location.pathname === "/dashboard";

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdown(false);
      }
    };

    if (dropdown) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [dropdown]); 

  return (
    <>
      <div className={`flex ${isFirstTest ? 'gap-3' : 'flex-col gap-2'} mx-auto font-gully font-bold`}>
        {isParent && (<StudentDropdown/>)}
        {isFirstTest && (
          <button
            className="flex p-3 items-center gap-3 self-stretch"
            onClick={() => navigate(isDashboard ? "/plans" : "/dashboard")}
          >
            {isDashboard ? <BiNotepad size={22} className="mb-1" /> : <BiGridAlt size={22} className="mb-1" />}
            <p className="text-satPrepBlack text-base">
              {isDashboard ? "Plans" : "Dashboard"}
            </p>
          </button>)
        }
        <button
          className="flex p-3 items-center gap-3 self-stretch"
          onClick={() => setDropdown(!dropdown)}
        >
          <MdOutlineSettings size={22} />
          <p className="text-satPrepBlack text-base">Settings</p>
        </button>
        <button
          className="flex p-3 items-center gap-3 self-stretch"
          onClick={handlelogOut}
        >
          <BiLogOut size={22} className="-ml-1 mr-1" />
          <p className="text-satPrepBlack text-base">Log Out</p>
        </button>
      </div>
      {dropdown &&
        createPortal(
          <div
            ref={dropdownRef}
            className={`flex flex-col items-start z-[9999] w-[248px] absolute ${ isFirstTest ? "top-[85px] right-[4%] ": "bottom-[7%] left-[180px]"} rounded-xl  shadow-error-screen bg-satPrepTransWhite backdrop-blur-sevenFive`}
          >
            <button
              className="flex w-full h-12 px-[14px] py-[18px] items-center gap-3 hover:bg-satPrepAccent hover:text-satPrepWhite hover:rounded-t-xl"
              onClick={() => handleOpenDialog("editProfile")}
            >
              <FaRegEdit className="w-6 h-6" />
              <p className="font-gully text-base font-medium">Edit Profile</p>
            </button>
            {isStudent && !data?.data && (
              <button
                className="flex w-full h-12 px-[14px] py-[18px] items-center gap-3 hover:bg-satPrepAccent hover:text-satPrepWhite"
                onClick={handleClickAddParentOrStudentDetails}
              >
                <MdOutlineLibraryAdd className="w-6 h-6" />
                <p className="font-gully text-base font-medium">
                  {isStudent ? "Add Parent Details" : "Add Student Details"}
                </p>
              </button>
            )}
            <button
              className="flex w-full h-12 px-[14px] py-[18px] items-center gap-3 hover:bg-satPrepAccent hover:text-satPrepWhite hover:rounded-b-xl"
              onClick={() => handleOpenDialog("changePassword")}
            >
              <BiLock className="w-6 h-6" />
              <p className="font-gully text-base font-medium">
                Change Password
              </p>
            </button>
          </div>,
          document.body
        )}
    </>
  );
}

const StudentDropdown = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [dropdown, setDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const { data: parentAssociatedData, isSuccess: parentAssociatedSuccess } =
    useGetParentStudentInfoQuery({});

  const { parentStudentId } = useSelector(
    (state: RootState) => state.root.startFullTest
  );

  const handleStudentSelection = (id: string) => {
    dispatch(setParentStudentId(id));
    setItem("studentId", id);
    navigate('/parentdashboard');
    dispatch(setIsTestCompletedDialogClosed(false));
  };

  const selectedStudent: StudentDetail =
    parentStudentId &&
    parentAssociatedData?.data?.length > 0 &&
    parentAssociatedData?.data?.find(
      (student: StudentDetail) => student.id === parentStudentId
    );

  useEffect(() => {
    const previousStudentId = getItem("studentId");
    if (!previousStudentId  && parentAssociatedSuccess && parentAssociatedData) {
      let studentId =
        parentAssociatedData.data.length > 0 && parentAssociatedData.data[0].id;
      if (studentId) {
        dispatch(setParentStudentId(studentId));
        //getUserResults(studentId);
        setItem("studentId", studentId);
      }
    }else if(previousStudentId){
      dispatch(setParentStudentId(previousStudentId));
    }
  }, [parentAssociatedSuccess, parentAssociatedData]);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdown(false);
      }
    };

    if (dropdown) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [dropdown]);

  const isDropdownAvailable =
    parentAssociatedData?.data && parentAssociatedData?.data?.length > 0;

  return (
    <>
      <button
        className="flex p-3 items-center gap-3 self-stretch"
        onClick={() => setDropdown(!dropdown)}
      >
        <BiUserCircle size={22} />
        <p className="text-satPrepBlack text-base">
          {getFullName(selectedStudent?.firstName, selectedStudent?.lastName)}
        </p>
      </button>

      {dropdown && (
        <div
          ref={dropdownRef}
          className={`flex flex-col items-start z-[9999] w-[200px] absolute top-[80%] left-[95%] max-h-48 overflow-y-auto scroll4 bg-satPrepTransWhite rounded-xl shadow-profile-nav`}
        >
          {isDropdownAvailable ? (
            parentAssociatedData.data.map(
              (student: StudentDetail, index: number) => {
                const fullName = getFullName(
                  student.firstName,
                  student.lastName
                );
                const isSelected =
                  fullName ===
                  getFullName(
                    selectedStudent.firstName,
                    selectedStudent.lastName
                  );
                const displayName = `${student?.firstName} ${student?.lastName}`.length > 13
                  ? `${student?.firstName} ${student?.lastName}`.substring(0, 13) + "..."
                  : `${student?.firstName} ${student?.lastName}`;
                return (
                  <button
                    key={student.id}
                    className={`py-[18px] px-[14px] flex gap-3 w-full text-base font-gully font-medium text-start hover:bg-satPrepAccent hover:text-white text-gray-900
                  ${index === 0 ? "rounded-t-xl" : ""}
                  ${
                    index === parentAssociatedData.data.length - 1
                      ? "rounded-b-xl"
                      : ""
                  }
                  ${isSelected ? "bg-satPrepAccent text-white" : ""}`}
                    onClick={() => handleStudentSelection(student.id)}
                  >
                    <BiCheck
                      className="-mt-[2px]"
                      size={24}
                      style={{ visibility: isSelected ? "visible" : "hidden" }}
                    />
                    {displayName}
                  </button>
                );
              }
            )
          ) : (
            <div className="py-[18px] px-[14px] text-gray-500">
              No students available
            </div>
          )}
        </div>
      )}
    </>
  );
};